export const optimization = [
  {
    id: 0,
    name: '无',
    media: [10, 16, 32, 45]
  },
  {
    id: 1,
    name: '激活',
    media: [10, 16, 32, 45]
  },
  {
    id: 2,
    name: '注册',
    media: [10, 16, 32, 45]
  },
  {
    id: 5,
    name: '付费',
    media: [10, 32, 45]
  },
  {
    id: 6,
    name: '次留',
    media: [10, 16]
  },
  {
    id: 15,
    name: '直播间观看',
    media: [10]
  },
  {
    id: 16,
    name: '直播间停留',
    media: [10]
  },
  {
    id: 17,
    name: '直播间内打赏',
    media: [10]
  },
  {
    id: 18,
    name: '账号关注',
    media: [10]
  },
  {
    id: 19,
    name: '组件点击',
    media: [10]
  },
  {
    id: 20,
    name: '粉丝入群',
    media: [10]
  },
  {
    id: 21,
    name: '表单预约',
    media: [10, 16, 32]
  },
  {
    id: 22,
    name: '预约下载',
    media: [10, 16, 32]
  },
  {
    id: 23,
    name: '关键行为',
    media: [10]
  },
  {
    id: 4,
    name: '首次付费',
    media: [16]
  },
  {
    id: 12,
    name: '付费次数',
    media: [16]
  },
  {
    id: 13,
    name: '下单',
    media: [16]
  },
  {
    id: 5,
    name: '行为数',
    media: [32]
  },
  {
    id: 7,
    name: '首日ROI',
    media: [32]
  },
  {
    id: 11,
    name: '七日ROI',
    media: [32]
  },
  {
    id: 14,
    name: '七日付费次数',
    media: [32]
  }
]

export const deepOptimization = [
  {
    id: 0,
    name: '无',
    media: [10, 16, 32, 45]
  },
  {
    id: 7,
    name: 'ROI系数',
    media: [10]
  },
  {
    id: 8,
    name: '每次付费',
    media: [10]
  },
  {
    id: 9,
    name: '双出价',
    media: [10]
  },
  {
    id: 10,
    name: 'ROI自动优化',
    media: [10]
  },
  {
    id: 14,
    name: '首日ROI+7日ROI',
    media: [10]
  },
  {
    id: 15,
    name: '每次付费+7日ROI',
    media: [10]
  },
  {
    id: 25,
    name: '变现ROI',
    media: [10]
  },
  {
    id: 26,
    name: '变现ROI-7日',
    media: [10]
  },
  {
    id: 27,
    name: '付费ROI-30日',
    media: [10]
  },
  {
    id: 2,
    name: '注册',
    media: [16, 45]
  },
  {
    id: 4,
    name: '首次付费',
    media: [16]
  },
  {
    id: 6,
    name: '次留',
    media: [16]
  },
  {
    id: 7,
    name: '首日付费ROI',
    media: [16]
  },
  {
    id: 11,
    name: '七日付费ROI',
    media: [16]
  },
  {
    id: 12,
    name: '付费次数',
    media: [16]
  },
  {
    id: 13,
    name: '下单',
    media: [16]
  },
  {
    id: 24,
    name: '小游戏-30日付费ROI',
    media: [16]
  },
  {
    id: 28,
    name: '首日变现ROI',
    media: [16]
  },
  {
    id: 29,
    name: '七日变现ROI',
    media: [16]
  },
  {
    id: 30,
    name: '30天变现ROI',
    media: [16]
  },
  {
    id: 6,
    name: '次留',
    media: [32]
  },
  {
    id: 5,
    name: '付费',
    media: [32, 45]
  },
  {
    id: 7,
    name: '付费ROI',
    media: [32, 45]
  }
]

export const deliveryTypeList = [
  { code: 'TENCENT_SMART', name: '腾讯-智投普通计划', mediaId: 16, mediaName: '腾讯' },
  { code: 'TENCENT_NORMAL', name: '腾讯-非智投普通计划', mediaId: 16, mediaName: '腾讯' },
  { code: 'TENCENT_SEARCH', name: '腾讯-搜索计划', mediaId: 16, mediaName: '腾讯' },
  { code: 'TENCENT_SEARCH_SMART', name: '腾讯-搜索计划升级版', mediaId: 16, mediaName: '腾讯' },
  { code: 'BYTEDANCE_SEARCH', name: '巨量-搜索计划', mediaId: 10, mediaName: '巨量引擎' },
  { code: 'BYTEDANCE_NORMAL', name: '巨量-普通计划', mediaId: 10, mediaName: '巨量引擎' },
  { code: 'KUAISHOU_AUTO', name: '快手-自动投放', mediaId: 32, mediaName: '磁力引擎' },
  { code: 'KUAISHOU_MANUAL', name: '快手-手动投放', mediaId: 32, mediaName: '磁力引擎' }
]

export const biddingStrategysData = [
  { id: 1, name: '稳定成本' },
  { id: 2, name: '最大转化投放' },
  { id: 106, name: '最大转化量投放' },
  { id: 3, name: '最优成本' },
  { id: 4, name: '计划潜力探索' },
  { id: 5, name: '稳定拿量' },
  { id: 102, name: '优先拿量' },
  { id: 103, name: '优先低成本' },
  { id: 104, name: '控制成本上限' },
  { id: 105, name: '常规投放' }
]

export const launchSourceData = [
  {
    value: 1,
    label: '自然量'
  },
  {
    value: 2,
    label: '投放量'
  }
]

export const genderData = [
  { id: 0, name: '不限' },
  { id: 1, name: '男' },
  { id: 2, name: '女' }
]
export const mediaPlatformData = [
  { label: '不限', value: 0 },
  { label: '安卓平台', value: 1 },
  { label: 'IOS平台', value: 2 },
  { label: '鸿蒙平台', value: 5 }
]
